import React, { useEffect, useState, forwardRef, useImperativeHandle } from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';

const EventStream = forwardRef((props, ref) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const user = useSelector((state) => state.auth.user);

  useImperativeHandle(ref, () => ({
    clearEvents: () => {
      setEvents([]);
    }
  }));

  const handleClearEvents = () => {
    setEvents([]);
  };

  const triggerTestEvent = async () => {
    if (!user || !user.uid) {
      console.error('User is not defined or missing UID');
      return;
    }
    try {
      // const response = await axios.post('http://localhost:4010/test-event', { userId: user.uid });
      const response = await axios.post(process.env.REACT_APP_STREAM_EXTENDED_NEURO_URL + '/test-event', { userId: user.uid });
      console.log('Test event triggered:', response.data);
    } catch (error) {
      console.error('Error triggering test event:', error);
    }
  };

  useEffect(() => {
    let eventSource;

    const setupEventSource = () => {
      if (user && user.uid) {
        setLoading(false);
        console.log('Attempting to connect to EventSource');
        // eventSource = new EventSource(`http://localhost:4010/events?userId=${user.uid}`);
        eventSource = new EventSource(process.env.REACT_APP_STREAM_EXTENDED_NEURO_URL + `/events?userId=${user.uid}`);
        eventSource.onmessage = (event) => {
          console.log('Raw event received:', event);
          try {
            const newEvent = JSON.parse(event.data);
            console.log('Parsed event:', newEvent);
            setEvents((prevEvents) => [...prevEvents, newEvent]);
          } catch (error) {
            console.error('Error parsing event data:', error);
            console.log('Raw event data:', event.data);
          }
        };

        eventSource.onerror = (error) => {
          console.error('EventSource failed:', error);
          eventSource.close();
        };

        eventSource.onopen = () => {
          console.log('EventSource connection opened');
        };
      } else {
        console.error('User is not defined or missing UID');
        setLoading(false);
      }
    };

    setupEventSource();

    return () => {
      if (eventSource) {
        console.log('Closing EventSource connection');
        eventSource.close();
      }
    };
  }, [user]);

  if (!user || !user.uid) {
    return <div className="text-sm text-red-600">User not authenticated</div>;
  }

  return (
    <div className="p-2">
      <div className="flex justify-end space-x-2 mb-2">
        <button
          onClick={triggerTestEvent}
          className="px-2 py-1 text-sm bg-blue-500 text-white rounded hover:bg-blue-600"
        >
          Trigger Test Event
        </button>
        <button
          onClick={handleClearEvents}
          className="px-2 py-1 text-sm bg-red-500 text-white rounded hover:bg-red-600"
        >
          Clear Events
        </button>
      </div>
      {loading ? (
        <p className="text-sm text-gray-600">Loading...</p>
      ) : events.length === 0 ? (
        <p className="text-sm text-gray-600">No events received yet.</p>
      ) : (
        <ul className="space-y-1 max-h-60 overflow-y-auto">
          {events.map((event, index) => (
            <li key={index} className="text-sm bg-gray-100 p-1 rounded">
              <span className="font-semibold">{event.type}:</span> {event.message}
              <span className="text-xs text-gray-500 ml-1">({event.timestamp})</span>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
});

export default EventStream;
